export default __webpack_public_path__ + "static/michael-gfeller-layer5-maintainer-50206aaff8fcbcd4862563d21e9f4997.webp";